@if (user) {
  <pp-user-management-user-row
    [ppUser]="ppUser"
    [ppAccountId]="ppAccountId"
    [ppExpanded]="expanded"
    (ppExpandedChange)="onExpandedChange($event)"
  ></pp-user-management-user-row>
  @if (expanded) {
    <pp-user-management-user-section-sites
      [ppUser]="ppUser"
      [ppCustomFields]="ppCustomFields"
      [ppIsClosing]="isClosing"
    ></pp-user-management-user-section-sites>
  }
}
